// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e39fb35b","355":"1fd05948","433":"32b3be53","455":"36998c1b","690":"f07ebd4b","977":"44cef3fa"}[chunkId] + ".chunk.js";
};